<template>
  <ArchiveView />
</template>

<script>
import ArchiveView from "../views/Archive.vue";
export default {
  name: "Archive",
  components: { ArchiveView },
};
</script>
